<template>
  <div>
    <Dialog :value="visible" width="40vw" @input="handleClose">
      <template #header>Yellow Bus Budget Codes</template>
      <template #body>
        <v-data-table :headers="budgetCodesHeaders" :items="budgetCodes" dense disable-sort hide-default-footer>
          <template v-slot:item.costPerMile="{ item }">
            {{ toMoney(item.costPerMile, 4) }}
          </template>
          <template v-slot:footer>
            <div class="total-cost">
              <h3>Total Cost Per Mile:</h3>
              <h3>{{ totalCostPerMile }}</h3>
            </div>
          </template>
        </v-data-table>
      </template>
    </Dialog>
  </div>
</template>
<script>
import { Dialog } from '@/components/shared';
import { mapGetters } from 'vuex';
import { toMoney } from '@/util';

export default {
  props: {
    visible: { type: Boolean, default: false },
  },
  components: { Dialog },
  computed: {
    ...mapGetters('config', ['yellowBusConfig']),
    budgetCodes() {
      return this.yellowBusConfig?.budgetCodes || [];
    },
    totalCostPerMile() {
      const total = this.budgetCodes.reduce((a, b) => a + Number(b.costPerMile), 0);
      return toMoney(total, 4);
    },
  },
  data() {
    return {
      toMoney,
      budgetCodesHeaders: [
        { text: 'Line #', value: 'lineNumber' },
        { text: 'Budget Code', value: 'budgetCode' },
        { text: 'Description', value: 'description' },
        { text: 'Cost Per Mile', value: 'costPerMile', align: 'right' },
      ],
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style>
.total-cost {
  float: right;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
}
</style>
